import { render, staticRenderFns } from "./Kpivalue.vue?vue&type=template&id=7a83d760&"
import script from "./Kpivalue.vue?vue&type=script&lang=js&"
export * from "./Kpivalue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7a83d760', component.options)
    } else {
      api.reload('7a83d760', component.options)
    }
    module.hot.accept("./Kpivalue.vue?vue&type=template&id=7a83d760&", function () {
      api.rerender('7a83d760', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Kpi/Kpivalue.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Kpi/Kpivalue.vue
// module id = WhXD
// module chunks = 0